<div class="spacer"></div>
<div class="container container-border container-size">
  <h2>{{ anwendungsname }}</h2>
</div>

<div class="spacer"></div>
<div class="container container-border container-size">
  <div class="row">
    <div class="col-md-12">
      <h4>Literatur</h4>
    </div>
  </div>
  <mat-card>
    <p>
      BMEL (2022): Ausführungsanweisung zum BMEL-Jahresabschluss.
      https://www.bmel-statistik.de/fileadmin/daten/BFB-0113004-2022.pdf,
      Zugriff am 18.01.2023
    </p>
    <p>
      erostat (2022): Statistical regions in the European Union and partner
      countries NUTS and statistical regions 2021 - reedition 2022.
      https://ec.europa.eu/eurostat/web/products-manuals-and-guidelines/-/ks-gq-22-010,
      Zugriff am 18.01.2023
    </p>
    <p>
      EU (2015): Durchführungsverordnung (EU) 2015/220 der Kommission vom 3.
      Februar 2015 mit Durchführungsbestimmungen zur Verordnung (EG) Nr.
      1217/2009 des Rates zur Bildung eines Informationsnetzes
      landwirtschaftlicher Buchführungen über die Einkommenslage und die
      betriebswirtschaftlichen Verhältnisse landwirtschaftlicher Betriebe in der
      Europäischen Union. https://lexparency.de/eu/32015R0220/, Zugriff am
      18.01.2023
    </p>
    <p>
      EU (2019): Durchführungsverordnung (EU) 2019/1975 der Kommission vom 31.
      Oktober 2019 zur Änderung der Durchführungsverordnung (EU) 2015/220 mit
      Durchführungsbestimmungen zur Verordnung (EG) Nr. 1217/2009 des Rates zur
      Bildung eines Informationsnetzes landwirtschaftlicher Buchführungen über
      die Einkommenslage und die betriebswirtschaftlichen Verhältnisse
      landwirtschaftlicher Betriebe in der Europäischen Union.
      https://eur-lex.europa.eu/legal-content/DE/TXT/PDF/?uri=CELEX:32019R1975&rid=10,
      Zugriff am 18.01.2023
    </p>
  </mat-card>

  <div class="spacer"></div>
  <mat-card>
    <div class="row">
      <div class="col-md-2">
        <button
          (click)="goBack()"
          mat-raised-button
          color="primary"
          class="custom-btn mt-3"
          type="button"
        >
          <fa-icon
            [icon]="faArrowLeft"
            class="ml-1 icon-vertical-align"
          ></fa-icon>
          Zurück
        </button>
      </div>
    </div>
  </mat-card>
</div>
<div class="spacer"></div>
